import React from 'react';
import { ScrollRestoration, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import PageHero from './PageHero';
import AnimateOnScroll from './AnimateOnScroll';
import dekorativne from '../resources/dekorativne.jpg';
import kamen from '../resources/Kamenivo 8-16.jpeg';
import piesok from '../resources/piesok.jpg';
import strkopiesky from '../resources/strkopiesky.jpg';

const categories = [
  { img: strkopiesky, label: 'ŠTRKOPIESKY', route: '/ponuka/strkopiesky' },
  { img: kamen,       label: 'KAMENIVO',    route: '/ponuka/kamenivo'    },
  { img: piesok,      label: 'PIESOK',      route: '/ponuka/piesok'      },
  { img: dekorativne, label: 'OKRASNÝ KAMEŇ', route: '/ponuka/okrasny'  },
];

function Ponuka() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <PageHero title="Naša" highlight="ponuka" subtitle="Vyberte si kategóriu stavebného materiálu." />

      <div className="flex-1 max-w-screen-xl mx-auto w-full px-6 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 h-full">
          {categories.map((cat, i) => (
            <AnimateOnScroll key={i} delay={i * 100}>
              <div
                className="relative h-72 sm:h-80 lg:h-96 cursor-pointer rounded-xl overflow-hidden shadow-md hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 group"
                onClick={() => navigate(cat.route)}
              >
                <img
                  src={cat.img}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  alt={cat.label}
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 group-hover:bg-opacity-60 transition-all duration-300">
                  <span className="text-white text-3xl font-bold tracking-wide drop-shadow-lg">
                    {cat.label}
                  </span>
                </div>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>

      <Footer />
      <ScrollRestoration />
    </div>
  );
}

export default Ponuka;
